export default "__VITE_ASSET__ffbb187c__"